import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef, useId } from 'react';

import theme from 'theme';

// Source: images/email-unsubscribed-icon.svg. White separators reveal the background.
export const EmailUnsubscribedIcon = forwardRef<SVGSVGElement, BaseIconProps>(
  function EmailUnsubscribedIcon(props, ref) {
    const clipId = useId();
    return (
      <BaseIcon
        ref={ref}
        viewBox="0 0 17 18"
        width={17}
        height={18}
        fill={theme.palette.secondary.main}
        stroke="none"
        {...props}
      >
        <defs>
          <clipPath id={clipId}>
            <path
              clipRule="evenodd"
              d="M0 0H17V18H0Z M6 12.5a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0-11 0Z"
            />
          </clipPath>
        </defs>
        <g clipPath={`url(#${clipId})`}>
          <path d="M11.25 0.75H0.75C0.3 0.75 0 1.05 0 1.5V2.55L6 5.925L12 2.625V1.5C12 1.05 11.7 0.75 11.25 0.75Z" />
          <path d="M5.625 6.425L0 3.275V10.5C0 10.95 0.3 11.25 0.75 11.25H11.25C11.7 11.25 12 10.95 12 10.5V3.275L6.375 6.425C6.165 6.53 5.835 6.53 5.625 6.425Z" />
        </g>
        <path
          fill={theme.palette.error.main}
          fillRule="evenodd"
          d="M7 12.5a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0-9 0Z M11 10h1v3h-1Z M11 14h1v1h-1Z"
        />
      </BaseIcon>
    );
  },
);
